import React, { useEffect } from "react";
import { withPrefix } from "gatsby";
import styled from "styled-components";
import Title from "@airasia/phoenix-components/components/Title";
import Carousel from "@airasia/phoenix-widgets/widgets/Carousel";
import FAQ from "@airasia/phoenix-widgets/widgets/FAQ";

import UNIVERSAL_HEADER_DATA from "../../data/header";
import HERO_BANNER_DATA from "../../data/th/herobanner";
import CATEGORY_DATA from "../../data/th/category";
import FAQ_DATA from "../../data/th/faq";
import ProductCarousel_data from "../../data/th/ProductCarousel";
import Layout from "../../components/layout";
import "../../css/main.css";
import { fireGtmEvent } from "../../utils/functions";

const ContentWrapper = styled.div`
max-width: 625px;
margin-bottom: 24px;

#title, h2 {
font-size: 2.5rem;
font-weight: 700;
text-align: center;
margin-bottom: 30px;
}


@media only screen and (min-width: 720px) {
width: 90%;
max-width: 976px;
margin: 0 auto 48px;
}

@media only screen and (min-width: 1025px) {
width: 90%;
max-width: 1224px;
margin: 0 auto 48px;
}
`;

const TitleWrapper = styled.div`
margin-bottom: 3em;

#title, h2 {
font-size: 2.5rem;
font-weight: 700;
text-align: center;
}

#subtitle {
font-size: 1.2rem;
line-height: 2rem;
text-align: center;
margin-top: 20px;
font-weight: 400;
}

a {
color: rgb(220, 50, 36);
text-decoration: none;
}
@media only screen and (max-width: 720px){
width: 90%;
margin: 2em auto;

#title {
font-size: 24px;
line-height: 28px;
margin-bottom: 10px;
}

#subtitle {
font-size: 1rem;
line-height: 1.5rem;
}
}
`;

const TextContentWrapper = styled.div`
width: 90%;
margin: 0 16px 24px;

#title, h3 {
font-size: 2rem;
font-weight: 700;
text-align: center;
margin-bottom: 30px;
}

@media only screen and (min-width: 720px) {
width: 90%;
max-width: 976px;
margin: 0 auto 48px;
}

@media only screen and (min-width: 1025px) {
width: 90%;
max-width: 1224px;
margin: 0 auto 48px;
}
`;

const IndexTHPage = () => {
let header = UNIVERSAL_HEADER_DATA;
header.defaultLocale = [
{
data: [
{
default: '/th/',
icon: 'LanguageIcon',
longform: 'English (Thailand)',
shortform: 'EN'
}
]
}
]
header.localeList = [
{
data: [
{
default: '/th/',
icon: 'LanguageIcon',
longform: 'English (Thailand)',
shortform: 'EN'
},
{
default: '/th/th/',
icon: 'LanguageIcon',
longform: 'ภาษาไทย',
shortform: 'TH'
},
{
default: '/id/',
longform: 'English (Indonesia)',
shortform: 'EN'
},
{
default: '/',
longform: 'English (Malaysia)',
shortform: 'EN'
},
{
default: '/id/id/',
longform: 'Bahasa Indonesia',
shortform: 'ID'
}
]
}
]

const updateLocale = (obj) => {
window.location.href = withPrefix(obj.detail)
}

useEffect(() => {
if (typeof window !== 'undefined') {
window.addEventListener("uhfLocaleChange", updateLocale)
}
}, [])

return (
<Layout
        canonical="https://www.airasia.com/aa/shop/th/"
        title="Online shop for duty-free products & more in Indonesia | airasia Shop "
        description="Get all your needs from fashion, electronics, skincare, liquor and more at the lowest prices from the best online shopping in Indonesia! Delivered to you anywhere! Shop now!"
        bannerData={HERO_BANNER_DATA}
        headerData={UNIVERSAL_HEADER_DATA}
>
    <br />
    <ContentWrapper>
        <TitleWrapper>
            <Title
                    accessible
                    inverted={false}
                    textAlign="left"
                    type="h1"
                    customProperties={{ id: "title" }}
            >
            airasia shop - Fly High, Great Buys
            </Title>
            <Title
                    accessible
                    inverted={false}
                    textAlign="left"
                    theme="AIRASIA_CLASSIC"
                    type="h2"
                    customProperties={{ id: "subtitle" }}
            >
            Shop for duty-free products on the go with multiple delivery
            options. <br />
            From in-flight to home delivery, buy exciting duty-free goods at
            unbeatable prices!
            </Title>
        </TitleWrapper>
    </ContentWrapper>
    <ContentWrapper>
        <Carousel
                accessible={false}
                allowLocaleFormat={false}
                cardConfig={{
                cardHeaderHeight: "180px",
        customGridTemplate: {
        desktop: "18",
        mobile: "12",
        },
        customImageMinSize: "120px",
        focusEffect: true,
        hoverEffect: true,
        imageHoverAnimation: true,
        }}
        data={CATEGORY_DATA.data}
        templateType="productCategory"
        theme="AIRASIA_CLASSIC"
        widgetName="Carousel"
        />
    </ContentWrapper>
    <br />
    <br />
    <ContentWrapper>
        <Carousel
                accessible
                allowLocaleFormat={false}
                cardConfig={{
                cardHeaderHeight: "300px",
        }}
        data={ProductCarousel_data.data}
        heading={ProductCarousel_data.heading}
        isHideFooter={false}
        isLoading={false}
        showFormattedPrice
        showMoreTextTarget="self"
        templateType="productCard"
        theme="AIRASIA_CLASSIC"
        widgetName="Carousel"
        />
    </ContentWrapper>
    <br /><br /><br />
    <TextContentWrapper>
        <FAQ
                titleMarginBottom="normal"
                titleType="h3"
                title="Frequently Asked Questions"
                data={FAQ_DATA}
                openFirstItem
        />
    </TextContentWrapper>
</Layout>
);
};
export default IndexTHPage;
